import styled, { css } from 'styled-components';
import useFavouriteToggle from '../hooks/useFavouriteToggle';
import React from 'react';
import { FavouriteButton } from './IndexListItem';
import { TOP_BAR_HEIGHT } from '../constants';

export const TOP_BAR_BOX_SHADOW_CSS = css`
  box-shadow: var(--shadow-inset);
`;

const ResourceTopBar = styled.div<{ isCanvas?: boolean; noBorder?: boolean }>`
  min-height: ${TOP_BAR_HEIGHT}px;
  height: ${TOP_BAR_HEIGHT}px;
  ${(props) => !props.noBorder && TOP_BAR_BOX_SHADOW_CSS};

  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0px 24px;
  background-color: var(--color-bg-primary);
`;

export const ResourceFavouriteButton = ({
  type,
  typeId,
  name,
}: {
  type:
    | 'report'
    | 'dashboard'
    | 'wallboard'
    | 'workspace'
    | 'scorecard'
    | 'targetsApp';
  typeId: string;
  name: string;
}) => {
  const { isFavourite, onFavouriteToggled } = useFavouriteToggle({
    type,
    typeId,
    name,
  });

  return (
    <FavouriteButton isFavourite={isFavourite} onClick={onFavouriteToggled} />
  );
};

export default ResourceTopBar;
